type HandOffState = { tab?: number } & Record<string, unknown>;

export type HistoryWithTab = {
  location: { pathname: string, state?: HandOffState },
  replace: (pathname: string, state: HandOffState) => void,
};

// Inbox and rejected only: the ad-applications tab reads categories that are not loaded yet on mount.
const tabsOtherPagesMayOpen = [1, 2];

export const handedOverTab = (location?: { state?: HandOffState }) => {
  const tab = location?.state?.tab;
  return tab !== undefined && tabsOtherPagesMayOpen.includes(tab) ? tab : 0;
};

export const clearHandedOverTab = (history?: HistoryWithTab) => {
  const state = history?.location.state;
  if (history && state?.tab !== undefined) {
    history.replace(history.location.pathname, { ...state, tab: undefined });
  }
};
